export default __webpack_public_path__ + "static/media/VIDEOREEL (Disable).7ccdb689.png";